import { VectorLayer } from './Layer';
import { useEffect, useState } from 'react';
import IconFeature from './IconFeature';
import { SCRIPT_URL } from '../model/StaticVariables';

const MapMarkerLayer = (props) => {
    const { map, zIndex, markerCoords = [] } = props;
    const [features, setFeatures] = useState([]);

    useEffect(() => {
        const addFeatures = [];
        for (let mark of markerCoords) {
            let { center } = mark;
            if (center) {
                const icon = SCRIPT_URL + '/map-marker.svg';
                var marker = IconFeature({
                    poi: false,
                    x: center[0],
                    y: center[1],
                    color: '#016c29',
                    icon: icon
                });

                addFeatures.push(marker);
            }
        }
        setFeatures(addFeatures);
    }, [markerCoords]);

    return <VectorLayer visible={true} title={'map-marker'} className={'marker'} features={features} zIndex={zIndex} map={map} />;
};
export { MapMarkerLayer };
